import React from "react";
import * as S from "./OsAddon.styles";
import { SPECIAL_REQUESTS } from "../../../../../shared/utils/util-constants";
import CustomCheckbox from "../../../../../stories/core-components/Checkbox/Checkbox";

export interface LanguageOptions {
  title: string;
  price: string;
  id: string;
}

export interface OsAddonList {
  selected : boolean, 
  name : string, 
  subtitle : string, 
  id : string, 
  price : string, 
  notSelectOnClick : boolean
  showBorder ?: boolean;
  infoText ?: string;
  options ?: LanguageOptions[] | undefined;
}

interface OsAddonProps {
  checkboxList: Array<OsAddonList>
  onItemClick: (id, optionId) => void
  handleLangaueClick: (id) => void
  selectedLanguage: string
  showLoader: boolean
}

const OSAddon: React.FC<OsAddonProps> = ({
  checkboxList = [],
  onItemClick,
  handleLangaueClick,
  selectedLanguage,
  showLoader
}) => {

  const [loadingItemId, setLoadingItemId] = React.useState<string | null>(null);
  React.useEffect(() => {
    if(!showLoader) {
      setLoadingItemId(null);
    }
  },[showLoader])
  const handleItemClick = (id: string, optionId: string | undefined) => {
    setLoadingItemId(id);
    onItemClick(id, optionId);
  };

  const handleLangaugeOptionClick = (optionId:string) => {
    setLoadingItemId(null);
    handleLangaueClick(optionId);
  }

  return (
    <S.OSAddonCont>
      <S.OSAddonHeader>
        {SPECIAL_REQUESTS}
      </S.OSAddonHeader>
      <S.HorizontalLine />
      <S.CheckboxListCont>
        {checkboxList.map((item, index) => (
          <S.CheckboxCont key={index} showBorder={item.showBorder}>
            <CustomCheckbox 
              title={item?.name}
              checked={item?.selected}
              onClickCb={() => handleItemClick(item?.id, item?.options?.[0]?.id)}
              subtitle={item?.subtitle}
              suffixText={item?.price}
              infoText={item?.infoText}
              options={item?.options}
              handleLangaueClick={handleLangaugeOptionClick}
              selectedLanguage={selectedLanguage}
              showLoader={loadingItemId === item.id && showLoader}
            />
           {index !== checkboxList.length-1 && <S.HrLine />}
          </S.CheckboxCont>
        ))}
      </S.CheckboxListCont>
    </S.OSAddonCont>
  );
};

export default React.memo(OSAddon);
